<template>
    <SwLayout>
        <div class="dm-wizard-field" v-if="presentation && presentation.content">
            <!-- <pre>{{ presentation }}</pre> -->
            <input
                type="text"
                v-model="presentation.content.title"
                class="form-control mb-6"
                id="dm-manuscript-title"
                maxlength="180"
                :placeholder="translate('Enter manuscript title')"
                @change="savePresentation()"
            />

            <h6 class="mt-6 mb-6">
                {{ translate("Co-authors / illustrators (if relevant)") }}
            </h6>

            <input
                type="text"
                v-model="presentation.content.co_authors"
                class="form-control"
                id="dm-co-authors"
                maxlength="180"
                :placeholder="
                    translate(
                        'Enter the full name(s) of any co-authors / illustrators',
                    )
                "
                @change="savePresentation()"
            />
        </div>
    </SwLayout>
</template>

<script>
import { validationMixin } from "@/mixins/validationMixin.js";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState, mapActions } from "pinia";

export default {
    mixins: [validationMixin],

    computed: {
        ...mapWritableState(useSubmissionWizardStore, [
            "presentation",
            "bottom_navigation_rules",
        ]),

        isValid() {
            if (!this.presentation) return false;
            if (!this.presentation.content) return false;
            if (!this.presentation.content.title) return false;
            return this.presentation.content.title.trim().length >= 1;
        },
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["savePresentation"]),
    },
};
</script>
